<template>
  <div class="container-fluid">
    <form v-if="!isMerge" style="padding: 3em 0 2em 0;">
      <!-- <p style="text-align: left;" for="exampleInputEmail1">输入短链接</p>
      <div class="form-row align-items-center">
        <div class="col-sm-6 my-1">
          <label class="sr-only" for="inlineFormInputName">Name</label>
          <input type="text" class="form-control" v-model="passiveLink">
        </div>
        <div class="col-auto my-1">
          <button @click="query" type="button" class="btn btn-success">查询</button>
        </div>
      </div> -->
      <h3>点击图标直接合并</h3>
      <!-- <br/> -->
      <div class="row">
          <div @click="appMerge(appDetail.app.shortLink,appDetail.iconData.iconUrl)" style="cursor: pointer;" v-for="(appDetail,index) in appDetailList" :key="index" class="col-md-2">
            <img style="width:6em;" :src="appDetail.iconData.iconUrl"/>
            <p></p>
            <p style="font-size:18px">
              <i style="font-size:28px" :class="appDetail.app.osName=='iOS'?'os_icon iconfont icon-ios':'os_icon iconfont icon-anzhuo'"></i>
              &nbsp;&nbsp;{{appDetail['app']['appName']}}
            </p>
          </div>
        </div>
    </form>
    <div style="margin: 6em;" v-if="isMerge">
      <div>
        <img style="width:6em" :src="appIcon">
        <i style="margin:1em;font-size:2em" class="iconfont icon-hebing"></i>
        <img style="width:6em" :src="mergeIConData">
      </div>
      <div style="padding: 4em;">
        <button @click="cancel_merge" type="button" class="btn btn-warning">取消合并</button>
      </div>
    </div>
  </div>
</template>

<script>
var self;
export default {
  name: "HelloWorld",
  data() {
    return {
      shortLink: this.$route.params.app.shortLink,
      appIcon: this.$route.params.app.iConData!=null?this.$route.params.app.iConData:this.$route.params.app.iConUrl,
      isMerge: false,
      mergeIConData: "",
      mergeId: 0,
      passiveLink: "",
      appDetailList:[]
    };
  },
  mounted() {
    self = this;
    var shortLink = this.$route.params.app.shortLink;
    this.getAppInfo(shortLink);
    this.getAppMergeInfo(shortLink);
  },
  watch(){
  },
  methods: {
    query: function() {
      var shortLink = this.passiveLink.substr(
        this.passiveLink.lastIndexOf("/") + 1,
        4
      );
      console.log(shortLink);
      this.$http
        .post(this._Global.HTTP_SERVER + "/app/merge/passiveLink/query", {
          shortLink: shortLink
        })
        .then(response => {
          self.respDataHandle(response.body, function(data) {
            console.log(data);
            self.mergeIConData = data.iData;
          });
        });
    },
    cancel_merge: function(params) {
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/app/merge/delete", {
          authToken: this.getToken(),
          mergeId: this.mergeId
        })
        .then(response => {
          self.respDataHandle(response.body, function() {
            self.isMerge = false;
            self.mergeIConData = "";
            self.getAppMergeInfo()
          });
        });
    },
    appMerge:function (shortLink,mergeIConData) {
      this.passiveLink=shortLink
      this.mergeIConData=mergeIConData
      this.merge()
    },
    merge: function() {
      var passiveLink = this.passiveLink.substr(
        this.passiveLink.lastIndexOf("/") + 1,
        4
      );
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/app/merge", {
          authToken: this.getToken(),
          activeLink: this.shortLink,
          passiveLink: passiveLink
        })
        .then(response => {
          self.respDataHandle(response.body, function(data) {
            self.isMerge = true;
            self.mergeId = data.mergeId;
          });
        });
    },
    getAppInfo: function(shortLink) {
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/app/info", {
          link: shortLink,
          authToken: this.getToken()
        })
        .then(response => {
          self.respDataHandle(response.body, function(respData) {
            console.log(respData);
            self.app = respData;
            self.$emit("setApp", respData);
          });
        });
    },
    getAppMergeInfo: function(shortLink) {
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/app/merge/info", {
          shortLink: shortLink,
          authToken:this.getToken()
        })
        .then(response => {
          this.respDataHandle(response.body, function(data) {
            if (data.exist == 1) {
              self.isMerge = true;
              self.mergeIConData = data.iConData?data.iConData:data.iConUrl;
              self.mergeId = data.mergeId;
            }
            self.appDetailList=data.appDetailInfos
          });
        });
    }
  }
};
</script>

<style scoped>
input {
  border-radius: 2em;
}

img {
  border-radius: 1em;
}
</style>


// WEBPACK FOOTER //
// src/components/AppMerge.vue